import { DeliveryStore } from '../delivery-store';
import { IDeliveryStoreNoEditProps } from './delivery-store-no-edit.models';

export const DeliveryStoreNoEdit = ({
  storeData, withBorder, isFulfilledOrder,
}: IDeliveryStoreNoEditProps): JSX.Element => (
    <DeliveryStore
      storeData={storeData}
      withBorder={withBorder}
      isFulfilledOrder={isFulfilledOrder}
    />
);
